var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"m-auto"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"spinner","size":"3x"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }